import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import { useQuery } from '@tanstack/react-query';
import { NavLink } from 'react-router-dom';

import { vencidosDaAvaliacao } from '../filaDaAvaliadora/vencidos';
import { gruposDeNavegacao, mapaDeNavegacao } from '../navegacao/mapaDeNavegacao';

/** O número do menu: falha ou modo mock deixa o item sem número (`TP-065`, `D6`). */
function useVencidosDaAvaliacao(): number {
  return useQuery(vencidosDaAvaliacao()).data ?? 0;
}

export const LARGURA_DA_BARRA = 264;

/**
 * As 13 entradas, lidas do mapa único.
 *
 * As que ainda não existem aparecem no menu, com um selo dizendo isso —
 * escondê-las daria a impressão de um produto menor do que ele é, e
 * mostrá-las sem marcar daria a impressão de um produto pronto. As duas
 * mentiras custam confiança; o selo não custa nada.
 */
export function BarraLateral(): React.JSX.Element {
  const vencidos = useVencidosDaAvaliacao();
  return (
    <Box component="nav" aria-label="Telas do produto" sx={{ py: 1 }}>
      {gruposDeNavegacao.map((grupo) => (
        <List
          key={grupo}
          dense
          disablePadding
          subheader={
            <ListSubheader disableSticky sx={{ bgcolor: 'transparent', lineHeight: '28px' }}>
              {grupo}
            </ListSubheader>
          }
          sx={{ px: 1, pb: 1 }}
        >
          {mapaDeNavegacao
            .filter((entrada) => entrada.grupo === grupo)
            .map((entrada) => {
              const Icone = entrada.icone;
              return (
                <ListItemButton
                  key={entrada.chave}
                  component={NavLink}
                  to={entrada.caminho}
                  sx={{ '&.active': { bgcolor: 'action.selected', fontWeight: 600 } }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <Icone fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={entrada.rotulo} slotProps={{ primary: { variant: 'body2', noWrap: true } }} />
                  {entrada.chave === 'fila-da-avaliacao' && vencidos > 0 ? (
                    <Chip
                      label={vencidos}
                      size="small"
                      color="error"
                      aria-label={`${String(vencidos)} ${vencidos === 1 ? 'aceite vencido' : 'aceites vencidos'}`}
                      sx={{ height: 18, fontSize: '0.6875rem' }}
                    />
                  ) : null}
                  {!entrada.construida ? (
                    <Chip
                      label="Em breve"
                      size="small"
                      sx={(tema) => ({
                        height: 18,
                        fontSize: '0.625rem',
                        backgroundColor: tema.palette.sla.semPrazo.fundo,
                        color: tema.palette.sla.semPrazo.tinta,
                        border: `1px solid ${tema.palette.sla.semPrazo.borda}`,
                      })}
                    />
                  ) : null}
                </ListItemButton>
              );
            })}
        </List>
      ))}
    </Box>
  );
}
